import { useMutation } from '@tanstack/react-query';
import { createAdminFeedbackCycle } from './requests';

const useCreateAdminFeedbackCycle = () =>
  useMutation({
    mutationFn: createAdminFeedbackCycle,
  });

export default useCreateAdminFeedbackCycle;
